import {
  BRANDING_PRIMARY,
  BRANDING_SECONDARY,
  BRANDING_BUTTON_PRIMARY_COLOR,
  BACKGROUND_COLOR,
  FOREGROUND_COLOR,
  BUTTON_TEXT,
  INPUT_BORDER_OUTLINE,
  BRANDING_PRIMARY_TEXT,
  BRANDING_SECONDARY_TEXT,
  BRANDING_BUTTON_COLOR,
  PRIMARY_DEFAULT_COLOR,
  BUTTON_PRIMARY_DEFAULT_COLOR,
  SECONDARY_DEFAULT_COLOR,
  BACKGROUND_DEFAULT_COLOR,
  FOREGROUND_DEFAULT_COLOR,
  BUTTON_DEFAULT_TEXT_COLOR,
  INPUT_BORDER_OUTLINE_DEFAULT_COLOR,
  PRIMARY_EMBEDDED_DEFAULT_COLOR,
  BUTTON_EMBEDDED_PRIMARY_DEFAULT_COLOR
} from 'portal-modules/auth/constants/keys'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import validateHexaColor from 'portal-modules/common/utils/validate-hexa-color'
const showEmbeddedView = getEmbeddedViewFlag()

export default settings => {
  if (showEmbeddedView) {
    var background_color = settings[BACKGROUND_COLOR]
    var foreground_color = settings[FOREGROUND_COLOR]
    var button_text = settings[BUTTON_TEXT]
    var input_border_outline = settings[INPUT_BORDER_OUTLINE]
    var primary_text = settings[BRANDING_PRIMARY_TEXT]
    var button_color = settings[BRANDING_BUTTON_COLOR]
    var secondary_text = settings[BRANDING_SECONDARY_TEXT]

    settings[BACKGROUND_COLOR] = validateHexaColor(
      `#${background_color.replace('#', '')}`,
    )
      ? `#${background_color.replace('#', '')}`
      : BACKGROUND_DEFAULT_COLOR
    settings[FOREGROUND_COLOR] = validateHexaColor(
      `#${foreground_color.replace('#', '')}`,
    )
      ? `#${foreground_color.replace('#', '')}`
      : FOREGROUND_DEFAULT_COLOR
    settings[BUTTON_TEXT] = validateHexaColor(
      `#${button_text.replace('#', '')}`,
    )
      ? `#${button_text.replace('#', '')}`
      : BUTTON_DEFAULT_TEXT_COLOR
    settings[INPUT_BORDER_OUTLINE] = validateHexaColor(
      `#${input_border_outline.replace('#', '')}`,
    )
      ? `#${input_border_outline.replace('#', '')}`
      : INPUT_BORDER_OUTLINE_DEFAULT_COLOR

    settings[BRANDING_PRIMARY] = validateHexaColor(
      `#${primary_text.replace('#', '')}`,
    )
      ? `#${primary_text.replace('#', '')}`
      : PRIMARY_EMBEDDED_DEFAULT_COLOR
    settings[BRANDING_BUTTON_PRIMARY_COLOR] = validateHexaColor(
      `#${button_color?.replace('#', '')}`,
    )
      ? `#${button_color?.replace('#', '')}`
      : BUTTON_EMBEDDED_PRIMARY_DEFAULT_COLOR
    settings[BRANDING_SECONDARY] = validateHexaColor(
      `#${secondary_text.replace('#', '')}`,
    )
      ? `#${secondary_text.replace('#', '')}`
      : SECONDARY_DEFAULT_COLOR
  } else {
    var primary = settings[BRANDING_PRIMARY]
    var button_primary = settings[BRANDING_BUTTON_PRIMARY_COLOR]
    var secondary = settings[BRANDING_SECONDARY]

    settings[BRANDING_PRIMARY] = validateHexaColor(
      `#${primary.replace('#', '')}`,
    )
      ? `#${primary.replace('#', '')}`
      : PRIMARY_DEFAULT_COLOR
    settings[BRANDING_BUTTON_PRIMARY_COLOR] = validateHexaColor(
      `#${button_primary?.replace('#', '')}`,
    )
      ? `#${button_primary?.replace('#', '')}`
      : BUTTON_PRIMARY_DEFAULT_COLOR
    settings[BRANDING_SECONDARY] = validateHexaColor(
      `#${secondary.replace('#', '')}`,
    )
      ? `#${secondary.replace('#', '')}`
      : SECONDARY_DEFAULT_COLOR
  }

  return settings
}
